import ApiProxy from "@/src/scripts/ts/ApiProxy";
import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import EZAlert from "@root/components/popups/EZAlert";
import FormTools from "@root/ts/FormTools";
import PatternSamples from "@root/ts/PatternSamples";

export default class Searchbar extends ComponentBase
{
  constructor(elem: ComponentElem)
  {
    super(elem);

    let inputElem = this.$root.find("input")[0] as HTMLInputElement;
    inputElem.value = "";

    const urlParams = new URLSearchParams(window.location.search);
    const keyword = urlParams.get('keyword');
    if (keyword) {
      inputElem.value = keyword;
    }

    inputElem.addEventListener("keydown", (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        event.preventDefault();
      
        let keyword = inputElem.value;
        if(PatternSamples.simple.test(keyword))
        {
          window.location.href = ApiProxy.getCommonPageData().search_page_path + "?keyword=" + keyword;
        }
        else
        {
          EZAlert.alert("請輸入城市、景點或活動名稱");
        }
      }
    })

    this.$root.find(".btn-enter").on("click", (event:JQuery.ClickEvent)=>
    {
      event.preventDefault();
      
      let keyword = inputElem.value;
      if(PatternSamples.simple.test(keyword))
      {
        window.location.href = ApiProxy.getCommonPageData().search_page_path + "?keyword=" + keyword;
      }
      else
      {
        EZAlert.alert("請輸入城市、景點或活動名稱");
      }
    });
    
  }
}